// Кодмод Фазы 1 миграции на Vite (13.08.2026): require('*.png') → ESM-импорты.
// Vite не исполняет CommonJS в браузере ('require is not defined'); webpack
// понимает ESM-импорты ассетов так же (asset/resource → URL-строка).
import img0 from '@images/UI/3d/star/red.png';
import img1 from '@images/UI/3d/star/red@2x.png';
import img2 from '@images/UI/3d/star/red@3x.png';
import img3 from '@images/UI/3d/star/silver.png';
import img4 from '@images/UI/3d/star/silver@2x.png';
import img5 from '@images/UI/3d/star/silver@3x.png';
import img6 from '@images/UI/3d/star/yellow.png';
import img7 from '@images/UI/3d/star/yellow@2x.png';
import img8 from '@images/UI/3d/star/yellow@3x.png';
import img9 from '@images/UI/3d/bag/white.png';
import img10 from '@images/UI/3d/bag/white@2x.png';
import img11 from '@images/UI/3d/bag/white@3x.png';
import img12 from '@images/UI/3d/gift-box/pink.png';
import img13 from '@images/UI/3d/gift-box/pink@2x.png';
import img14 from '@images/UI/3d/gift-box/pink@3x.png';
import img15 from '@images/UI/3d/box-with-coins/white.png';
import img16 from '@images/UI/3d/box-with-coins/white@2x.png';
import img17 from '@images/UI/3d/box-with-coins/white@3x.png';
import img18 from '@images/UI/3d/coins/gold.png';
import img19 from '@images/UI/3d/coins/gold@2x.png';
import img20 from '@images/UI/3d/coins/gold@3x.png';
import img21 from '@images/UI/3d/cart/pink.png';
import img22 from '@images/UI/3d/cart/pink@2x.png';
import img23 from '@images/UI/3d/cart/pink@3x.png';
import img24 from '@images/UI/3d/check-mark/green.png';
import img25 from '@images/UI/3d/check-mark/green@2x.png';
import img26 from '@images/UI/3d/check-mark/green@3x.png';
import img27 from '@images/UI/3d/cartRotated/pink.png';
import img28 from '@images/UI/3d/cartRotated/pink@2x.png';
import img29 from '@images/UI/3d/cartRotated/pink@3x.png';

export default {
  threeD: {
    star: {
      red: {
        x1: img0,
        x2: img1,
        x3: img2
      },
      silver: {
        x1: img3,
        x2: img4,
        x3: img5
      },
      yellow: {
        x1: img6,
        x2: img7,
        x3: img8
      }
    },
    bag: {
      white: {
        x1: img9,
        x2: img10,
        x3: img11
      }
    },
    pinkGiftBox: {
      x1: img12,
      x2: img13,
      x3: img14
    },
    boxWithCoins: {
      x1: img15,
      x2: img16,
      x3: img17
    },
    coins: {
      x1: img18,
      x2: img19,
      x3: img20
    },
    cart: {
      x1: img21,
      x2: img22,
      x3: img23
    },
    checkMark: {
      green: {
        x1: img24,
        x2: img25,
        x3: img26
      }
    },
    cartRotated: {
      pink: {
        x1: img27,
        x2: img28,
        x3: img29
      }
    }
  }
};
